import { createReducer } from '@reduxjs/toolkit';
import * as actions from '../actions';
import { IAccountState, NetworkRequest, NetworkRequestStatus } from '../types';

const {
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure
} = actions;

const initialRequestState: NetworkRequest = {
  status: NetworkRequestStatus.NONE,
  message: '',
  error: ''
};

const initialState: IAccountState = {
  forgotPassword: initialRequestState,
  resetPassword: initialRequestState
};

const loginReducer = createReducer(initialState, {
  [forgotPasswordStart.type]: state => {
    state.forgotPassword.status = NetworkRequestStatus.LOADING;
  },
  [forgotPasswordSuccess.type]: state => {
    state.forgotPassword.status = NetworkRequestStatus.SUCCESS;
  },
  [forgotPasswordFailure.type]: state => {
    state.forgotPassword.status = NetworkRequestStatus.ERROR;
  },
  [resetPasswordStart.type]: state => {
    state.resetPassword.status = NetworkRequestStatus.LOADING;
  },
  [resetPasswordSuccess.type]: state => {
    state.resetPassword.status = NetworkRequestStatus.SUCCESS;
  },
  [resetPasswordFailure.type]: state => {
    state.resetPassword.status = NetworkRequestStatus.ERROR;
  }
});

export { loginReducer };
